export class EquipScheduleA {
  equipId: number;
  scheduleANumber: number;
}
